module.exports = __webpack_public_path__ + "img/source02_01.c86e4635.png";